// extracted by mini-css-extract-plugin
export default {"round":"HistoryRound_round__k09HD","block":"HistoryRound_block__tWy32","show":"HistoryRound_show__S+MKX","hide":"HistoryRound_hide__wMq8F"};